import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface RaporPersonelState {
  enableServis: boolean;
  selectServisInfo: number | null;
  personelIds: number[];
  fetchingPersonel: boolean;
}

const RaporPersonelSlice = createSlice<RaporPersonelState, MapReducerPayloads<RaporPersonelState, {
  setEnableServis: boolean;
  setSelectServisInfo: number | null;
  setPersonelIds: number[];
  setFetchingPersonel: boolean;

}>>({
  name: "raporPersonel",
  initialState: {
    enableServis: false,
    selectServisInfo: null,
    personelIds: [],
    fetchingPersonel: false
  },
  reducers: {
    setEnableServis: (state, action) => {
      state.enableServis = action.payload;
    },
    setSelectServisInfo: (state, action) => {
      state.selectServisInfo = action.payload;
    },
    setPersonelIds: (state, action) => {
      state.personelIds = action.payload;
    },
    setFetchingPersonel: (state, action) => {
      state.fetchingPersonel = action.payload;
    },

  }
});

export default RaporPersonelSlice;

